<template>
  <div
    data-test-id="builder-app"
    role="dialog"
    aria-modal="true"
    ref="builder"
    tabindex="0"
    :aria-label="'Build your ' + productName"
    class="fixed inset-0 bg-white z-40 flex flex-col safe"
    :data-loading="!!loading"
  >
    <Loader
      data-test-id="builder-loader"
      overlay
      :visible="!!loading && !remuxLoading"
      class="absolute inset-0 text-blue-500 z-50"
      :label="translateString(loadingMessage)"
    />
    <PetLoader v-if="remuxLoading"></PetLoader>

    <Dialog
      data-close-confirm
      has-cancel-option
      :visible="showConfirmQuit"
      :cancel-label="$t('message.builder.dialogLabel.quit.cancelLabel')"
      :confirm-label="$t('message.builder.dialogLabel.quit.confirmLabel')"
      @confirm="handleClose"
      @cancel="showConfirmQuit = false"
    >
      <p tabindex="0">{{ $t('message.builder.quit') }}</p>
    </Dialog>

    <Dialog
      data-error
      :visible="!!error"
      type="negative"
      :confirm-label="$t('message.builder.dialogLabel.confirmLabel')"
      @confirm="handleCloseMessages"
    >
      <p>{{ translateString('message.constants.errors.', error) }}</p>
    </Dialog>

    <Dialog
      data-warning
      :visible="!!warning"
      type="alert"
      :confirm-label="$t('message.builder.dialogLabel.confirmLabel')"
      @confirm="handleCloseMessages"
    >
      <p>{{ translateString('message.constants.warnings.', warning) }}</p>
    </Dialog>

    <Dialog
        data-invalid
        :visible="!!invalid"
        type="negative"
        :confirm-label="$t('message.builder.dialogLabel.confirmLabel')"
        @confirm="handleClose"
    >
      <p>{{ translateString('message.constants.errors.', invalid) }}</p>
    </Dialog>

<!--    <Onboarding-->
<!--      data-onboarding-->
<!--      :visible="showOnboarding"-->
<!--      :heading="$t('message.builder.onboarding.didYouKnow')"-->
<!--      @close="handleCloseOnboarding"-->
<!--    >-->
<!--      <OnboardingSlide-->
<!--        :id="0"-->
<!--        animation="pinch"-->
<!--        :heading="$t('message.builder.onboarding.slide1.header')"-->
<!--        :body="$t('message.builder.onboarding.slide1.body')"-->
<!--        :bodyDesktop="$t('message.builder.onboarding.slide1.bodyDesktop')"-->
<!--        :image="require(`@vuedir/assets/onboarding/onboard-preview.jpg`)"-->
<!--        imageClass="animate-zoom"-->

<!--      />-->
<!--      <OnboardingSlide-->
<!--        :id="1"-->
<!--        animation="move"-->
<!--        :heading="$t('message.builder.onboarding.slide2.header')"-->
<!--        :body="$t('message.builder.onboarding.slide2.body')"-->
<!--        :bodyDesktop="$t('message.builder.onboarding.slide2.bodyDesktop')"-->
<!--        :image="require(`@vuedir/assets/onboarding/onboard-preview.jpg`)"-->
<!--        imageClass="animate-movearound"-->
<!--      />-->

<!--    </Onboarding>-->
      <Header class="border-b bg-white">
        <IconButton
            data-close-standalone
            icon="x"
            ref="closeBtn"
            :size="'medium'"
            :accessibility-label="$t('message.builder.header.closeAccessibility')"
            :position="'absolute'"
            class="h-14 top-0 right-0 z-20"
            @click="handleShowConfirmQuit"
        />
      </Header>
    <Body class="bg-gray-50 md:flex-row z-30"
          :class="[isMobile ? 'absolute w-full h-full top-0 left-0' : 'relative' ]"
          :style="isPetPortraitProduct ? 'height: calc(100% - 55px)' : ''">
        <div v-if="this.showFlyout !== null && isMobile"
             @click="cancelChanges"
             data-backdrop
             class="bg-black fixed top-0 left-0 w-full h-full z-30 bg-opacity-60 inset-0 filter" style="backdrop-filter: blur(3px);"></div>
        <div :aria-hidden="!isCollageProduct"
           :class="[wrapperPaddingClasslist, wrapperClasslist]">
        <div v-if="enableOffline && isPetPortraitProduct" class="absolute top-0 left-0 w-full flex items-center justify-center mt-5 z-20">
          <div class="mx-4 text-center bg-gray-200 px-3 py-2 rounded">
            {{ $t('message.builder.petPortraits.offlineNotification') }}
          </div>
        </div>
        <div class="h-full flex flex-grow w-full">
            <Printable
                    v-if="!showStandaloneImageEditor"
                    :key="hasImages"
                    :panels="panels"
                    :width="selectedWidth"
                    :height="selectedHeight"
                    :edge-dimension="edgeDimension"
                    :edge-color="edgeColor"
                    :edge-type="selectedEdge"
                    :render-mode="renderMode"
                    :frame="frameDimension"
                    :gap="gapDimension"
                    :mat="matDimension"
                    :isMobile="isMobile"
                    :selectedEditToolId="selectedEditToolId"
                    :wrapperPaddingClasslist="wrapperPaddingClasslist"
                    :featureFlags="featureFlags"
                    :mgiPhotoBorderBleed="photoBorderBleed"
            >
                <Panes
                        :panes="panes"
                        :key="stringifiedImageTransforms"
                        :width="selectedWidth"
                        :height="selectedHeight"
                        :edge="edgeDimension"
                        :edge-color="edgeColor"
                        :edge-type="selectedEdge"
                        :border="borderDimension"
                        :border-color="borderColorValue"
                        :images="images"
                        :events="!showPreview"
                        :upload-later="uploadLater"
                        :render-mode="renderMode"
                        :is-art="isArt"
                        :product-slug="productSlug"
                        :disable-collage-outer-border="disableCollageOuterBorder"
                        :filter="liveFilterAvailable(selectedFilter) ? selectedFilter : null"
                        :featureFlags="featureFlags"
                        :selectedEditToolId="selectedEditToolId"
                        :imageEditTrigger="imageEditTrigger"
                        :locale="locale"
                        :disableZoomCrop="disableZoomCrop"
                        :mgiPhotoBorderBleed="photoBorderBleed"
                        @paneClick="handlePaneClick"
                />
            </Printable>
            <Previews
                    v-if="!showStandaloneImageEditor"
                    :key="hasImages"
                    aria-hidden="true"
                    tabindex="-1"
                    :selectedEditToolId="selectedEditToolId"
                    :events="showPreview"
                    :visible="showPreview"
                    :width="selectedWidth"
                    :height="selectedHeight"
                    :frame="frameDimension"
                    :gap="gapDimension"
                    :mat="matDimension"
                    :render-mode="renderMode"
                    :cornerRadius="cornerRadius"
                    :can-manipulate="productSlug !== PRODUCT_ART_SINGLE_PANEL && productSlug !== PRODUCT_COLLAGE_FRAMED_PRINT"
                    :feature-flags="featureFlags"
                    :can-edit="canEdit"
                    :frame-color="frameColor"
                    :preview="showPreview"
                    :isMobile="isMobile"
                    :isArt="isArt"
                    :panels="panels"
                    :edge="edgeDimension"
                    :frameType="selectedFrame"
            >
            </Previews>
        </div>
    <template v-if="showImageEditorButton && !uploadLater">
      <div class="pb-4 flex justify-center z-20">
          <p v-if="isCollageProduct">
              <span v-if="!isMobile">{{$t('message.builder.standaloneImageEditor.instructions.desktop.collage')}}</span>
              <span v-if="isMobile">{{$t('message.builder.standaloneImageEditor.instructions.mobile.collage')}}</span>
          </p>
        <template v-if="isPetPortraitProduct">
          <button data-replace-image-pet-portraits
                  @click="handleShowImageSelector"

                  class="btn btn--outline text-blue-500 flex space-x-3 items-center font-bold">
            <svg class="w-6 h-6 text-blue-500 fill-current" viewBox="0 0 512 512"><path d="M80 24C80 10.7 90.7 0 104 0s24 10.7 24 24V350.1L350.1 128 160 128V80l238.1 0L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-73 73L432 384h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H432v56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-326.1L161.9 384H352v48H136c-30.9 0-56-25.1-56-56V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80H80V24z"/></svg>
            <span>{{$t('message.builder.standaloneImageEditor.buttons.replace')}}</span>
          </button>
        </template>
        <template v-if="!isCollageProduct && !isPetPortraitProduct">
          <button data-replace-image
                  @click="openImageEditor"
                  data-test-id="edit-or-replace-button"
                  class="btn btn--outline text-blue-500 flex space-x-3 items-center font-bold">
            <svg class="w-6 h-6 text-blue-500 fill-current" viewBox="0 0 512 512"><path d="M80 24C80 10.7 90.7 0 104 0s24 10.7 24 24V350.1L350.1 128 160 128V80l238.1 0L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-73 73L432 384h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H432v56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-326.1L161.9 384H352v48H136c-30.9 0-56-25.1-56-56V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80H80V24z"/></svg>
            <span>{{$t('message.builder.standaloneImageEditor.buttons.editReplaceImage')}}</span>
          </button>
        </template>
      </div>

    </template>

    <StandaloneImageEditor v-if="showStandaloneImageEditor"
                      data-standalone-image-editor
              :key="pane"
              @paneClick="handlePaneClick"
              @applyImageEdits="handleApplyImageEdits"
              @cancelImageEdits="handleCancelImageEdits"
              @rotateImage="handleRotateImage"
              @changeOrientation="handleOrientationChange"></StandaloneImageEditor>
    </div>
    <div :key="'flyout' + selectedEditToolId"
        class="flex flex-col-reverse md:flex-col md:w-2/5 md:border-l md:flex-grow-0 md:flex-shrink-0 lg:w-1/3 relative"
        isolation="isolate"
    >
        <transition name="transition-slide-fade-bottom-delay">
          <div v-if="canEdit && selectedEditToolId && isMobile"
               class="pointer-events-auto">
            <ImageEditor :isMobile="isMobile"></ImageEditor>
          </div>
        </transition>
        <transition v-if="isMobile && !loading && !showColorPicker" name="transition-slide-fade-bottom-delay">
          <div v-if="(!selectedEditToolId && isMobile) || !isMobile"
               class="text-center p-4 pt-0 md:p-2 md:bg-white md:border-t z-40 bg-white mt-3">
            <div
                v-if="showPreview && isCollageProduct && !canAddToCart"
                class="p-2 bg-blue-50 text-blue-500 text-xs border border-blue-500 rounded mb-2 cursor-pointer"
                @click="togglePreview(false)"
            >
              {{ $t('message.builder.notifications.selectIn2D') }}
            </div>
            <div
                v-if="uploadLater"
                class="p-2 bg-blue-50 text-blue-500 text-xs border border-blue-500 rounded mb-2"
            >
              {{ $t('message.builder.notifications.provideImageLater') }}
            </div>
            <section>
              <div v-html="finishedSizeLabel" class="text-gray-500 text-sm"></div>
              <div v-if="this.showFlyout !== null" class="flex items-center justify-between w-full pt-2">
                <ActionButton
                  data-test-id="calcel-add-to-cart"
                  class="btn btn--secondary w-1/2 text-lg mr-2"
                  data-changes-cancel
                  :aria-label="$t('message.builder.cancel')"
                  :label="$t('message.builder.cancel')"
                  @click="cancelChanges"
                />
                <ActionButton
                    data-test-id="add-to-cart"
                    class="btn btn--primary w-1/2 text-lg ml-2"
                    data-changes-apply
                    :aria-label="$t('message.builder.apply')"
                    :label="$t('message.builder.apply')"
                    @click="this.closeFlyout(this.showFlyout)"
                />
              </div>
              <div v-else class="flex items-center justify-between w-full pt-2">
                <div class="flex items-end justify-center w-1/2">
                  <span
                    v-if="hasDiscount"
                    data-discount-total
                    aria-hidden="true"
                    class="line-through text-gray-500 mr-1"
                  >{{ $filters.currency(totalPrice) }}</span>
                  <span
                      data-test-id="total"
                      class="text-blue-500 font-boldtext-xl"
                  ><span v-if="hasDiscount" class="sr-only">{{ $t('message.builder.discountedPriceLabel') }}</span><span data-total data-test-id="builder-total">{{ $filters.currency(totalPlusAdditionalAttributes) }}</span></span>
                </div>
                <ActionButton
                    data-test-id="add-to-cart"
                    class="btn btn--primary w-1/2 text-lg ml-2"
                    data-add-to-cart
                    :aria-label="addToCartLabel + ' ' + addToCartAriaLabel"
                    :label="addToCartLabel"
                    :disabled="!canAddToCart"
                    @click="handleAddToCart"
                />
              </div>
          </section>
        </div>
        </transition>
        <transition name="transition-slide-fade-bottom-delay">
          <div
          data-test-id="tabs"
            v-if="(!selectedEditToolId && isMobile) || !isMobile"
          class="relative z-30 md:flex md:flex-col md:flex-grow md:overflow-hidden"
        >
          <div role="tablist"
               aria-label="Customizable Options"
               class="relative bg-white flex z-10 items-center md:border-t-0">
            <IconButton
                v-if="layouts && Object.keys(layouts).length"
                role="tab"
                :id="'tab-' + 99"
                :aria-controls="'panel-' + 99"
                data-test-id="tab-button-layouts"
                :fixed="false"
                :icon="'layout'"
                :label="$t('message.builder.iconButtons.layouts')"
                :active="showFlyout === 99 || (showFlyoutDesktop === 99 && !isMobile)"
                :aria-selected="String(showFlyout === 99 || (showFlyoutDesktop === 99 && !isMobile))"
                @click="toggleFlyout(99)"
            />
            <IconButton
                role="tab"
                :id="'tab-' + 0"
                :aria-controls="'panel-' + 0"
                data-test-id="tab-button-sizes"
                :fixed="false"
                :icon="'maximize'"
                :label="$t('message.builder.iconButtons.sizes')"
                :active="showFlyout === 0 || (showFlyoutDesktop === 0 && !isMobile)"
                :aria-selected="String(showFlyout === 0 || (showFlyoutDesktop === 0 && !isMobile))"
                @click="toggleFlyout(0)"
            />
            <IconButton
                v-if="isPetPortraitProduct"
                role="tab"
                :id="'tab-' + 4"
                :aria-controls="'panel-' + 4"
                data-pet-portrait-icon-styles
                :fixed="false"
                :label="$t('message.builder.iconButtons.styles')"
                :active="showFlyout === 4"
                :aria-selected="String(showFlyout === 4)"
                @click="toggleFlyout(4)"
            >
            <template v-slot:iconSvg>
              <svg class="fill-current" viewBox="0 0 512 512" width="18" height="18">
                <path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/>
              </svg>
            </template></IconButton>
            <IconButton
              v-if="borders && Object.keys(borders).length"
              role="tab"
              :id="'tab-' + 88"
              :aria-controls="'panel-' + 88"
              data-test-id="tab-button-borders"
              :fixed="false"
              :icon="'grid'"
              :label="$t('message.builder.iconButtons.borders')"
              :active="showFlyout === 88 || (showFlyoutDesktop === 88 && !isMobile)"
              :aria-selected="String(showFlyout === 88 || (showFlyoutDesktop === 88 && !isMobile))"
              @click="toggleFlyout(88)"
            />
            <IconButton
                v-if="!isPetPortraitProduct && !isCollageCanvasProduct && (showEdgeOptions || showFrameOptions)"
                role="tab"
                :id="'tab-' + 1"
                :aria-controls="'panel-' + 1"
                data-test-id="tab-button-edges"
                :fixed="false"
                icon="square"
                :label="$t('message.builder.iconButtons.edges')"
                :active="showFlyout === 1 || (showFlyoutDesktop === 1 && !isMobile)"
                :aria-selected="String(showFlyout === 1 || (showFlyoutDesktop === 1 && !isMobile))"
                @click="toggleFlyout(1)"
            />
            <IconButton
              v-if="!isPetPortraitProduct && (showEdgeOptions || showFrameOptions)"
              role="tab"
              :id="'tab-' + 7"
              :aria-controls="'panel-' + 7"
              data-test-id="tab-button-frames"
              :fixed="false"
              :label="$t('message.builder.iconButtons.frames')"
              :active="showFlyout === 7 || (showFlyoutDesktop === 7 && !isMobile)"
              :aria-selected="String(showFlyout === 7 || (showFlyoutDesktop === 7 && !isMobile))"
              @click="toggleFlyout(7)"
            >
              <template v-slot:iconSvg>
                <svg  width="16" height="16" viewBox="0 0 16 16">
                  <path d="M6 3V2C6 1.44687 5.55312 1 5 1H2C1.44687 1 1 1.44687 1 2V14C1 14.0344 1.00313 14.0687 1.00625 14.1031C1.05625 14.6062 1.48438 15 2 15H14C14.5531 15 15 14.5531 15 14V11C15 10.4469 14.5531 10 14 10H7C7 10 6 10.0128 6 9V3ZM8 9H14C15.1031 9 16 9.89688 16 11V14C16 15.1031 15.1031 16 14 16H2C0.965625 16 0.1125 15.2125 0.009375 14.2031C0.003125 14.1344 0 14.0688 0 14V2C0 0.896875 0.896875 0 2 0H5C6.10313 0 7 0.896875 7 2V9H8Z"/>
                </svg>
              </template>
            </IconButton>
            <IconButton
              v-if="filters && Object.keys(filters).length"
              role="tab"
              :id="'tab-' + 2"
              :aria-controls="'panel-' + 2"
              data-test-id="tab-button-filters"
              :fixed="false"
              :label="$t('message.builder.iconButtons.filters')"
              :active="showFlyout === 2 || (showFlyoutDesktop === 2 && !isMobile)"
              :aria-selected="String(showFlyout === 2 || (showFlyoutDesktop === 2 && !isMobile))"
              @click="toggleFlyout(2)"
            >
              <template v-slot:iconSvg>
                <svg class="fill-current" viewBox="0 0 512 512" width="18" height="18">
                  <path d="M352 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5L41.2 295.8l63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3L177 432.1c9.3-4.9 20.5-4.9 29.8 0L285 473.3l-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM448 160c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176c0-8.8 7.2-16 16-16z"/>
                </svg>
              </template>
            </IconButton>
            <IconButton
              v-if="!isPillowProduct && !isPetPortraitProduct"
              role="tab"
              :id="'tab-' + 3"
              :aria-controls="'panel-' + 3"
              data-test-id="tab-button-services"
              :fixed="false"
              :label="$t('message.builder.iconButtons.services')"
              :active="showFlyout === 3 || (showFlyoutDesktop === 3 && !isMobile)"
              :aria-selected="String(showFlyout === 3 || (showFlyoutDesktop === 3 && !isMobile))"
              @click="toggleFlyout(3)"
            >
              <template v-slot:iconSvg>
                <svg class="fill-current" viewBox="0 0 640 512" width="18" height="18">
                  <path d="M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zm457-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"/>
                </svg>
              </template>
            </IconButton>
            <IconButton
                v-if="isPetPortraitProduct"
                role="tab"
                :id="'tab-' + 5"
                :aria-controls="'panel-' + 5"
                data-pet-portrait-icon-name
                :fixed="false"
                :icon="'type'"
                :label="$t('message.builder.iconButtons.name')"
                :active="showFlyout === 5"
                :aria-selected="String(showFlyout === 5)"
                @click="toggleFlyout(5)"
            />
            <IconButton
              v-if="isPetPortraitProduct"
              role="tab"
              :id="'tab-' + 6"
              :aria-controls="'panel-' + 6"
              data-pet-portrait-icon-notes
              :fixed="false"
              :icon="'edit-2'"
              :label="$t('message.builder.iconButtons.notes')"
              :active="showFlyout === 6"
              :aria-selected="String(showFlyout === 6)"
              @click="toggleFlyout(6)"
            />
          </div>
          <Flyout
            v-click-off="{ method: closeFlyout, args: [0] }"
            data-sizes
            :aria-labelledby="'tab-' + 0"
            :id="'panel-' + 0"
            role="tabpanel"
            :heading="$t('message.builder.flyout.sizes.heading')"
            :mobile-active="showFlyout === 0"
            :active="showFlyoutDesktop === 0"
            :aria-expanded="showFlyoutDesktop === 0 || showFlyout === 0"
            @close="closeFlyout(0)"
          >
            <div class="md:flex-col md:w-full md:rounded">
              <template v-if="loading && Object.keys(filteredSuggestedSizes).length === 0">
                <Option
                  v-for="n in 5"
                  :key="n"
                  placeholder
                />
              </template>
              <template v-else>
                <Option
                  v-for="(size, key, index) in filteredSuggestedSizes"
                  :key="key"
                  data-test-id="size"
                  :heading="panels === 3 ? labelPanels(size.sublabel) : size.label"
                  :subheading="panels === 3 ? finishedSizeLabelPanels(size.label) : ''"
                  :price="totalSizePrice(key)"
                  :discounted-price="hasDiscountForSize(key) ? totalSizePrice(key) * discountFactor : null"
                  :selected="selectedSize === key && !customSize"
                  :image="require(`@vuedir/assets/sizes/${productSlug}/${getThumbnailAspectRatio(size)}_${getThumbnailSize(size, index)}.jpg`)"
                  :class="'md:ml-0'"
                  @click="handleSelectSize(size)"
                />
                <Option
                  v-if="hasCustomSizes && !isSingleSize && !isPetPortraitProduct && !isPillowProduct"
                  data-test-id="size-custom"
                  data-custom-size
                  :heading="$t('message.builder.customSizeButton')"
                  :subheading="customSizeTriptychSublabel"
                  :image="require(`@vuedir/assets/sizes/${productSlug}/${aspectRatio}_custom.jpg`)"
                  :selected="customSize"
                  class="'md:ml-0'"
                  @click="handleSelectCustomSize"
                />
              </template>
            </div>
            <template
              v-if="customSize"
              v-slot:secondary
            >
              <div
                v-if="customSizesOptions"
                class="flex p-4 mt-2 border-t md:mt-0"
              >
                <Dropdown
                  data-test-id="custom-sizes-options"
                  class="w-full mr-1"
                  :bgColor="'bg-gray-50'"
                  :label="$t('message.builder.flyout.sizes.customSizes.widthAndHeight')"
                  :options="customSizesOptions"
                  :selected="selectedSize"
                  @changeEvent="handleCustomSize"
                />
              </div>
              <div
                v-else
                class="p-4 bg-gray-50"
              >
                <div class="flex items-center px-10 ml-5">
                  <Dropdown
                      class="w-28 mr-1"
                      :bgColor="'bg-gray-50'"
                      :label="$t('message.builder.flyout.sizes.customSizes.width')"
                      :options="customWidths"
                      :selected="selectedWidth.toString()"
                      @changeEvent="handleCustomWidth"
                  />
                  <vue-feather type="x" class="w-4 h-4 mx-4" />
                  <Dropdown
                      class="w-28 ml-1"
                      :bgColor="'bg-gray-50'"
                      :label="$t('message.builder.flyout.sizes.customSizes.height')"
                      :options="customHeights"
                      :selected="selectedHeight.toString()"
                      @changeEvent="handleCustomHeight"
                  />
                </div>
                <div v-html="wrapWithParentheses(finishedSizeLabel)" class="px-10 pt-2 ml-5 text-xs md:text-sm mt-1"></div>
              </div>
            </template>
          </Flyout>
          <Flyout
              v-if="layouts"
              v-click-off="{ method: closeFlyout, args: [99] }"
              data-layouts
              :aria-labelledby="'tab-' + 99"
              :id="'panel-' + 99"
              role="tabpanel"
              :icon="'layout'"
              :heading="$t('message.builder.flyout.layouts')"
              :mobile-active="showFlyout === 99"
              :active="showFlyoutDesktop === 99"
              :aria-expanded="showFlyoutDesktop === 99 || showFlyout === 99"
              @close="closeFlyout(99)"
          >
          <template v-slot:secondary>
            <div class="grid grid-cols-4 justify-center mb-4 gap-y-4 md:grid-cols-3 xl:grid-cols-4">
          <div v-for="(layout, key) in layouts"
               class="flex justify-center md:overflow-visible"
               @click="handleSelectLayout(layout)"
               @keyup.enter="handleSelectLayout(layout)">
              <LayoutThumbnail
                  :layout="layout"
                  :selected="selectedLayout === key"
                  :customWidth="selectedWidth"
                  :customHeight="selectedHeight"
                  :customSize="customSize"
                  tabindex="0"
                  role="option"
                  :aria-selected="String(selectedLayout === key)"
              />
            </div>
          </div>
          </template>
          </Flyout>
          <Flyout
            v-if="borders"
            v-click-off="{ method: closeFlyout, args: [88] }"
            data-borders
            :aria-labelledby="'tab-' + 88"
            :id="'panel-' + 88"
            role="tabpanel"
            :icon="'grid'"
            :heading="$t('message.builder.flyout.borders')"
            :mobile-active="showFlyout === 88"
            :active="showFlyoutDesktop === 88"
            :aria-expanded="showFlyoutDesktop === 88 || showFlyout === 88"
            @close="closeFlyout(88)"
          >
            <div class="md:flex-col md:w-full md:rounded">
              <Option
                v-for="(border, key, index) in borders"
                :key="`${selectedBorderColor}_${key}${borderDynamicThumbpath}`"
                data-test-id="border"
                :heading="border.description"
                :price="border.foreignPrice"
                :discounted-price="hasDiscount ? (border.foreignPrice * discountFactor) : null"
                :selected="selectedBorder === key"
                :image="require(`@vuedir/assets/borders/${productSlug}/${selectedBorderColor}_${key}${borderDynamicThumbpath}.jpg`)"
                @click="handleSelectBorder(border)"
                @keyup.enter="handleSelectBorder(border)"
              />
            </div>
            <div class="mt-4 md:flex-col md:w-full md:rounded">
              <Option
                v-for="(borderColor, key, index) in borderColors"
                :key="`${key}_${borderColorDynamicThumbpath}`"
                data-test-id="borderColor"
                :heading="borderColor.description"
                :price="borderColor.foreignPrice"
                :discounted-price="hasDiscount ? (borderColor.foreignPrice * discountFactor) : null"
                :selected="selectedBorderColor === key"
                :image="require(`@vuedir/assets/borders/${productSlug}/${key}_${borderColorDynamicThumbpath}.jpg`)"
                @click="handleSelectBorderColor(borderColor)"
                @keyup.enter="handleSelectBorderColor(borderColor)"
              />
            </div>
          </Flyout>
          <Flyout
            v-click-off="{ method: closeFlyout, args: [1] }"
            data-edges
            :aria-labelledby="'tab-' + 1"
            :id="'panel-' + 1"
            role="tabpanel"
            :icon="'maximize'"
            :heading="$t('message.builder.flyout.edges')"
            :mobile-active="showFlyout === 1"
            :active="showFlyoutDesktop === 1"
            :aria-expanded="showFlyoutDesktop === 1 || showFlyout === 1"
            @close="closeFlyout(1)"
          >
            <div v-if="!isCollageCanvasProduct" class="md:flex-col md:w-full md:rounded">
              <Option
                v-for="(edge, key, index) in edges"
                :key="`${key}_${selectedFrame}`"
                data-test-id="edge"
                data-edge
                :disabled="!allowedEdges[key]"
                :heading="edge.description"
                :selected="selectedEdge === key"
                :image="require(`@vuedir/assets/edges/${productSlug}/${key}${edgeFrameThumbnailPath}.jpg`)"
                :class="'md:ml-0'"
                @click="handleSelectEdge(edge)"
                @keyup.enter="handleSelectEdge(edge)"
              />
            </div>
          </Flyout>
          <Flyout
            v-click-off="{ method: closeFlyout, args: [7] }"
            data-frames
            :aria-labelledby="'tab-' + 7"
            :id="'panel-' + 7"
            role="tabpanel"
            :heading="$t('message.builder.flyout.frames')"
            :mobile-active="showFlyout === 7"
            :active="showFlyoutDesktop === 7"
            :aria-expanded="showFlyoutDesktop === 7 || showFlyout === 7"
            @close="closeFlyout(7)"
          >
            <div class="'md:mt-4 md:flex-col md:w-full md:rounded md:ml-0">
                <Option
                  v-if="!isPetPortraitProduct && showFrameOptions"
                  data-test-id="frame-none"
                  data-frame-none
                  :heading="$t('message.builder.flyout.filters.blankOption')"
                  :image="require(`@vuedir/assets/frames/${productSlug}/075DW${frameEdgeThumbnailPath}.jpg`)"
                  :selected="selectedFrame === '075DW'"
                  class="'md:ml-0'"
                  @click="handleSelectFrame({ code: '075DW' })"
                  @keyup.enter="handleSelectFrame({ code: '075DW' })"
                />
                <Option
                  v-for="(frame, key, index) in supportedFrames"
                  data-test-id="frame"
                  data-frame
                  :heading="frame.description"
                  :selected="selectedFrame === key"
                  :image="require(`@vuedir/assets/frames/${productSlug}/${key}${frameEdgeThumbnailPath}.jpg`)"
                  :class="'md:ml-0'"
                  @click="handleSelectFrame(frame)"
                  @keyup.enter="handleSelectFrame(frame)"
                />
            </div>
            <template v-slot:iconSvg class="mt-1">
              <svg class="fill-current" width="16" height="16" viewBox="0 0 16 16">
                <path d="M6 3V2C6 1.44687 5.55312 1 5 1H2C1.44687 1 1 1.44687 1 2V14C1 14.0344 1.00313 14.0687 1.00625 14.1031C1.05625 14.6062 1.48438 15 2 15H14C14.5531 15 15 14.5531 15 14V11C15 10.4469 14.5531 10 14 10H7C7 10 6 10.0128 6 9V3ZM8 9H14C15.1031 9 16 9.89688 16 11V14C16 15.1031 15.1031 16 14 16H2C0.965625 16 0.1125 15.2125 0.009375 14.2031C0.003125 14.1344 0 14.0688 0 14V2C0 0.896875 0.896875 0 2 0H5C6.10313 0 7 0.896875 7 2V9H8Z"/>
              </svg>
            </template>
          </Flyout>
          <Flyout
              v-if="isPetPortraitProduct"
              v-click-off="{ method: closeFlyout, args: [4] }"
              data-styles-flyout
              :aria-labelledby="'tab-' + 4"
              :id="'panel-' + 4"
              role="tabpanel"
              :heading="!showColorPicker ? $t('message.builder.flyout.styles') : ''"
              :mobile-active="showFlyout === 4"
              :active="showFlyoutDesktop === 4"
              :aria-expanded="showFlyout === 4"
              @close="closeFlyout(4)"
          >
          <div v-if="!showColorPicker" class="w-full">
              <Option
                  v-for="(styleObject, index) in remuxFilters"
                  :key="styleObject.name"
                  :selected="selectedPetPortraitStyle === styleObject.name"
                  :data-wd-id="`color-${index}`"
                  :image="require('@vuedir/assets/styles/CPPLPP/Square_' + index + '.jpg')"
                  data-test-id="filter-none"
                  :heading="styleObject.name"
                  :class="'md:ml-0'"
                  @click="handleSelectStyle(styleObject)"
                  @keyup.enter="handleSelectStyle(styleObject)"
              />
            <div v-if="['oil','comicbook'].includes(selectedPetPortraitStyle)">
            <h2
                  data-heading
                  class="font-bold mb-2 mt-8 ml-5"
                  tabindex="0"
              >
                Colors
              </h2>
              <Option
                  :key="'custom-color'"
                  data-custom-color-option
                  data-test-id="custom-color-selector"
                  :heading="'Select a Color'"
                  :color="selectedPetPortraitColor"
                  @click="showColorPicker = true"
              />
            </div>
            </div>

            <div v-if="showColorPicker" class="w-full">
              <ColorPicker v-if="selectedPetPortraitColor" :defaultColor="selectedPetPortraitColor" @applyColor="handleChangeColor" @cancel="showColorPicker = false"></ColorPicker>
            </div>
            <template v-slot:iconSvg>
              <svg class="fill-current" viewBox="0 0 512 512" width="18" height="18">
                <path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/>
              </svg>
            </template>
          </Flyout>
          <Flyout
            v-if="filters"
            v-click-off="{ method: closeFlyout, args: [2] }"
            data-filters
            :aria-labelledby="'tab-' + 2"
            :id="'panel-' + 2"
            role="tabpanel"
            :heading="$t('message.builder.flyout.filters.heading')"
            :mobile-active="showFlyout === 2"
            :active="showFlyoutDesktop === 2"
            :aria-expanded="showFlyoutDesktop === 2 || showFlyout === 2"
            @close="closeFlyout(2)"
          >
          <div class="pb-2"><span class="text-blue-500 font-bold italic text-xs pl-4">{{ $t('message.builder.flyout.filters.previewsAvailable') }}</span></div>
            <Option
              v-if="filters"
              data-test-id="filter-none"
              data-filter-none
              :heading="$t('message.builder.flyout.filters.blankOption')"
              :image="require(`@vuedir/assets/filters/filter_none.jpg`)"
              :selected="!selectedFilter"
              class="mr-4 md:mr-0 mb-4"
              @click="handleSelectFilter({ code: null })"
              @keyup.enter="handleSelectFilter({ code: null })"
            />
              <template v-for="(filter, key, index) in filters">
                <Option
                  v-if="liveFilterAvailable(key)"
                  :key="key"
                  data-test-id="filter"
                  :heading="filter.description"
                  :price="filter.foreignPrice"
                  :selected="selectedFilter === key"
                  :image="require(`@vuedir/assets/filters/filter_${key}.jpg`)"
                  :class="'md:ml-0'"
                  @click="handleSelectFilter(filter)"
                  @keyup.enter="handleSelectFilter(filter)"
                />
            </template>
            <div class="py-2"><span class="text-blue-500 font-bold italic text-xs pl-4">{{ $t('message.builder.flyout.filters.noPreviewsAvailable') }}</span></div>
            <template v-for="(filter, key, index) in filters">
              <Option
                v-if="!liveFilterAvailable(key)"
                :key="key"
                data-test-id="filter"
                :heading="filter.description"
                :price="filter.foreignPrice"
                :selected="selectedFilter === key"
                :image="require(`@vuedir/assets/filters/filter_${key}.jpg`)"
                :class="'md:ml-0'"
                @click="handleSelectFilter(filter)"
                @keyup.enter="handleSelectFilter(filter)"
              />
          </template>
          <template v-slot:iconSvg>
            <svg class="fill-current" viewBox="0 0 512 512" width="18" height="18">
              <path d="M352 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5L41.2 295.8l63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3L177 432.1c9.3-4.9 20.5-4.9 29.8 0L285 473.3l-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM448 160c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176c0-8.8 7.2-16 16-16z"/>
            </svg>
          </template>
          </Flyout>
          <Flyout
            v-click-off="{ method: closeFlyout, args: [3] }"
            data-services
            :aria-labelledby="'tab-' + 3"
            :id="'panel-' + 3"
            role="tabpanel"
            :heading="$t('message.builder.flyout.services.heading')"
            :mobile-active="showFlyout === 3"
            :active="showFlyoutDesktop === 3"
            :aria-expanded="showFlyoutDesktop === 3 || showFlyout === 3"
            @close="closeFlyout(3)"
          >
            <div class="md:flex-col md:w-full md:rounded">
              <Option
                v-if="services"
                data-test-id="service-none"
                data-service-none
                :detailed="true"
                :heading="$t('message.builder.flyout.services.noneOption')"
                :subheading="$t('message.builder.flyout.services.noneOptionSubHeading')"
                :image="require(`@vuedir/assets/services/service_none.jpg`)"
                :selected="!selectedService"
                @click="handleSelectService({ code: null })"
                @keyup.enter="handleSelectService({ code: null })"
              >
                <template v-if="selectedService === null">
                    <div :class="this.layouts ? 'flex w-full p-4 md:mt-0 bg-gray-50': 'flex w-full p-4 md:mt-0 bg-gray-50'">
                      <Textfield
                        id="instructions"
                        data-test-id="instructions"
                        name="instructions"
                        :label="$t('message.builder.flyout.services.adjustmentNotes')"
                        :placeholder="$t('message.builder.flyout.services.describeChanges')"
                        :bgColor="'bg-gray-50 text-sm'"
                        successText=""
                        class="w-full"
                        :value="note"
                        @inputEvent="handleNoteChange"
                      />
                    </div>
                  </template>
              </Option>
              <Option
                v-for="(service, key) in services"
                :key="key"
                data-test-id="service"
                :detailed="true"
                :heading="service.label"
                :subheading="service.description"
                :price="service.foreignPrice"
                :selected="selectedService === key"
                :image="require(`@vuedir/assets/services/service_${key}.jpg`)"
                class="md:ml-0"
                @click="handleSelectService(service)"
                @keyup.enter="handleSelectService(service)"
              >
                <template v-if="selectedService === key">
                  <div :class="this.layouts ? 'flex w-full p-4 md:mt-0 bg-gray-50': 'flex w-full p-4 md:mt-0 bg-gray-50'">
                    <Textfield
                      id="instructions"
                      data-test-id="instructions"
                      name="instructions"
                      :label="$t('message.builder.flyout.services.adjustmentNotes')"
                      :placeholder="$t('message.builder.flyout.services.describeChanges')"
                      :bgColor="'bg-gray-50 text-sm'"
                      class="w-full"
                      :value="note"
                      :required="requiresNotes"
                      errorText="(Required)"
                      successText="(Thank you!)"
                      @inputEvent="handleNoteChange"
                    />
                  </div>
                </template>
              </Option>
            </div>
            <template v-slot:iconSvg>
              <svg class="fill-current" viewBox="0 0 640 512" width="18" height="18">
                <path d="M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3zm457-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"/>
              </svg>
            </template>
          </Flyout>
          <Flyout
              v-click-off="{ method: closeFlyout, args: [5] }"
              data-pet-notes
              :aria-labelledby="'tab-' + 5"
              :id="'panel-' + 5"
              role="tabpanel"
              :icon="'type'"
              :heading="isMobile? petInputContent.petName.heading : ''"
              :active="showFlyoutDesktop === 5"
              :mobile-active="showFlyout === 5"
              :aria-expanded="showFlyout === 5"
              @close="closeFlyout(5)"
          >
          <div class="w-full">
              <label
                  for="petName"
                  class="text-black cursor-pointer block mb-1 ml-5">
                <span class="font-bold">{{ petInputContent.petName.inputLabel }}</span> <span class="italic">{{ $t('message.builder.petPortraits.name.optional') }}</span>
              </label>
              <div class="flex space-x-2 mb-1 md:mb-0 mx-5">
                <input
                    id="petName"
                    type="text"
                    name="petName"
                    minlength="1"
                    v-model="petName"
                    data-name
                    :placeholder="petInputContent.petName.placeholder"
                    class="form-input"
                    @keyup.enter="handleNameChange"
                >
                <ActionButton data-change-name-cta
                              :label="'Apply'"
                              :secondary="true"
                              :disabled="petPortraitName === petName"
                              @click="handleNameChange"></ActionButton>
              </div>
            </div>
          </Flyout>
          <Flyout
              v-click-off="{ method: closeFlyout, args: [6] }"
              data-notes
              :aria-labelledby="'tab-' + 6"
              :id="'panel-' + 6"
              role="tabpanel"
              :icon="'edit-2'"
              :heading="petInputContent.petNotes.heading"
              :mobile-active="showFlyout === 6"
              :active="showFlyoutDesktop === 6"
              :aria-expanded="showFlyout === 6"
              @close="closeFlyout(6)"
          >
          <div class="w-full px-5 italic">
              <i18n-t keypath="message.builder.petPortraits.notes.inputPrompt" class="text-sm italic" scope="global">
                <template v-slot:inputPromptEmphasis>
                  <span class="italic">{{ petInputContent.petNotes.inputPromptEmphasis }}</span>
                </template>
              </i18n-t>
              <p class="text-sm italic">{{ $t('message.builder.petPortraits.notes.inputInstructionsMobile') }}</p>
              <div class="flex py-4 mt-2 md:mt-0">
                <Textfield
                    id="notesMobile"
                    data-notes
                    name="notesMobile"
                    :label="petInputContent.petNotes.inputLabel"
                    :placeholder="petInputContent.petNotes.placeholder"
                    class="w-full"
                    :value="note"
                    :required="false"
                    @inputEvent="handleNoteChange"
                />
              </div>
            </div>
          </Flyout>
        </div>
      </transition>
      <transition v-if="!isMobile" name="transition-slide-fade-bottom-delay">
          <div v-if="(!selectedEditToolId && isMobile) || !isMobile"
               class="text-center p-4 pt-0 md:p-2 md:bg-white md:border-t">
            <div
                v-if="showPreview && isCollageProduct && !canAddToCart"
                class="p-2 bg-blue-50 text-blue-500 text-xs border border-blue-500 rounded mb-2 cursor-pointer"
                @click="togglePreview(false)"
            >
              {{ $t('message.builder.notifications.selectIn2D') }}
            </div>
            <div
                v-if="uploadLater"
                class="p-2 bg-blue-50 text-blue-500 text-xs border border-blue-500 rounded mb-2"
            >
              {{ $t('message.builder.notifications.provideImageLater') }}
            </div>
            <section>
              <div v-html="finishedSizeLabel" class="text-gray-500 text-sm"></div>
              <div class="flex items-center justify-between w-full pt-2">
                  <div class="flex items-end justify-center w-1/2">
                    <span
                      v-if="hasDiscount"
                      data-discount-total
                      aria-hidden="true"
                      class="line-through text-gray-500 mr-1"
                    >{{ $filters.currency(totalPrice) }}</span>
                    <span
                        data-test-id="total"
                        class="text-blue-500 font-boldtext-xl"
                    ><span v-if="hasDiscount" class="sr-only">{{ $t('message.builder.discountedPriceLabel') }}</span><span data-total data-test-id="builder-total">{{ $filters.currency(totalPlusAdditionalAttributes) }}</span></span>
                  </div>
                <ActionButton
                    data-test-id="add-to-cart"
                    class="btn btn--primary w-1/2 text-lg"
                    data-add-to-cart
                    :aria-label="addToCartLabel + ' ' + addToCartAriaLabel"
                    :label="addToCartLabel"
                    :disabled="!canAddToCart"
                    @click="handleAddToCart"
                />
              </div>
          </section>
        </div>
        </transition>
      </div>
    </Body>
    <transition-group name="transition-fade-in">
      <ImageSelector
          key="1"
          data-image-selector
          v-show="showImageSelector"
          :selected-images="selectedImages"
          :upload-later="supportsUploadLater"
          :feature-flags="featureFlags"
          :autoSelectSingleUpload="true"
          @uploadLater="handleUploadLater"
          @close="showImageSelector = false"
          @confirm="handleSelectImage"
      />

    <div v-if="showImageSelector"
         key="2"
         @click="showImageSelector = false"
         class="bg-black bg-opacity-75 absolute inset-0 z-30">
    </div>
    </transition-group>
    <div id="canvas" style="display: none;"></div>
  </div>
</template>

<script>
import * as dimensions from '@vuedir/constants/dimensions'
import * as errors from '@vuedir/constants/errors'
import * as routes from '@vuedir/constants/routes'
import * as measurements from '@vuedir/constants/measurements'
import { mapGetters, mapActions } from 'vuex'
import clickOffDirective, { LOADING_PROCESSING_IMAGE } from '@vuedir/directives/ClickOff'
import * as providers from '@vuedir/constants/artProviders'
import { locale } from '@vuedir/plugins/i18n/i18n'

import ActionButton from '@vuedir/components/ActionButton'
import Body from '@vuedir/components/Body'
import Dialog from '@vuedir/components/Dialog'
import Dropdown from '@vuedir/components/Dropdown'
import Flyout from '@vuedir/components/Flyout'
import Header from '@vuedir/components/Header'
import IconButton from '@vuedir/components/IconButton'
import ImageSelector from '@vuedir/components/ImageSelector'
import Loader from '@vuedir/components/Loader'
import Menu from '@vuedir/components/Menu'
import MenuItem from '@vuedir/components/MenuItem'
// import Onboarding from '@vuedir/components/Onboarding'
// import OnboardingSlide from '@vuedir/components/OnboardingSlide'
import Option from '@vuedir/components/Option'
import { Printable,
  StandaloneImageEditor,
  Panes,
  Previews,
  Textfield,
  supportsAR,
  sanitizeSvg,
  serializeSvg,
  trapTabFocus,
  translate,
  products,
  hideChatIcon,
  showChatIcon } from '@canvaspop/scoops'
import LayoutThumbnail from '@vuedir/components/LayoutThumbnail'
import Checkmark from '@vuedir/components/Checkmark'
import Styles from '@vuedir/components/Styles'
import ImageEditor from '@vuedir/components/ImageEditor'
import PetLoader from '@vuedir/components/PetLoader'
import ColorPicker from '@vuedir/components/ColorPicker'
import VueFeather from 'vue-feather';
import { computed } from 'vue'

/**
 * @const {HTMLBodyElement}
 */
const body = document.querySelector('body')

/**
 * Builder.vue
 */
export default {
  directives: {
    'click-off': clickOffDirective,
  },
  components: {
    ActionButton,
    Body,
    Dialog,
    Dropdown,
    Flyout,
    Header,
    IconButton,
    ImageSelector,
    Loader,
    Menu,
    MenuItem,
    // Onboarding,
    // OnboardingSlide,
    Option,
    Panes,
    Previews,
    Printable,
    Textfield,
    LayoutThumbnail,
    Checkmark,
    Styles,
    ImageEditor,
    StandaloneImageEditor,
    ColorPicker,
    VueFeather,
    PetLoader
  },

  data () {
    return {
      pane: 'pane_1',
      customSize: false,

      showImageSelector: false,
      showFlyout: null,
      showPreview: false,
      // showOnboarding: false,
      showConfirmQuit: false,
      showChat: false,
      isMobile: true,
      showFlyoutDesktop: 0,
      renderMode: false,
      PRODUCT_ART_SINGLE_PANEL: products.PRODUCT_ART_SINGLE_PANEL,
      PRODUCT_ART_FRAMED_PRINT: products.PRODUCT_ART_FRAMED_PRINT,
      PRODUCT_COLLAGE_FRAMED_PRINT: products.PRODUCT_COLLAGE_FRAMED_PRINT,
      userManuallySelectedCustom: false,
      artkit: null,
      flow: null,
      showPicker: false,
      petName: '',
      petInputContent: {
        petName: {
          heading: this.$t('message.builder.petPortraits.name.heading'),
          inputLabel: this.$t('message.builder.petPortraits.name.inputLabel'),
          placeholder: this.$t('message.builder.petPortraits.name.placeholder'),
        },
        petNotes: {
          heading: this.$t('message.builder.petPortraits.notes.heading'),
          inputLabel: this.$t('message.builder.petPortraits.notes.inputLabel'),
          placeholder: this.$t('message.builder.petPortraits.notes.inputPlaceholder'),
          inputPromptEmphasis: this.$t('message.builder.petPortraits.notes.inputPromptEmphasis')
        }
      },
      locale: locale,
      triggerElement: null,
      shadowPrintableTransforms: null,
      showColorPicker: false,
      showStandaloneImageEditor: false,
      colorPickerIsDirty: false,
      chatClientInitialized: false
    }
  },
  emits: ['close', 'chat'],
  watch: {
    layouts: function (val) {
      if (val) {
        this.showFlyoutDesktop = 99
      }
    },
    isMobile: function (val) {
      if (this.isPetPortraitProduct) {
        this.openMainFlyout()
      }
    }
  },
  computed: {
    ...mapGetters({
      featureFlags: 'app/featureFlags',
      artkitToken: 'app/artkitToken',

      loading: 'builder/loading',
      loadingMessage: 'builder/loadingMessage',
      error: 'builder/error',
      warning: 'builder/warning',
      invalid: 'builder/invalid',
      sizes: 'builder/sizes',
      customWidths: 'builder/customWidths',
      customHeights: 'builder/customHeights',
      customSizesOptions: 'builder/customSizesOptions',
      layouts: 'builder/layouts',
      borders: 'builder/borders',
      borderColors: 'builder/borderColors',
      panes: 'builder/panes',
      edges: 'builder/edges',
      allowedEdges: 'builder/allowedEdges',
      currentEdges: 'builder/currentEdges',
      currentFrames: 'builder/currentFrames',
      supportedFrames: 'builder/supportedFrames',
      filters: 'builder/filters',
      services: 'builder/services',
      filteredSuggestedSizes: 'builder/filteredSuggestedSizes',
      totalPrice: 'builder/totalPrice',
      discountFactor: 'builder/discountFactor',
      coupon: 'builder/coupon',
      couponSizes: 'builder/couponSizes',
      couponAmount: 'builder/couponAmount',
      isSingleSize: 'builder/isSingleSize',
      isArt: 'builder/isArt',
      petPortraitStyles: 'builder/petPortraitStyles',
      petPortraitColors: 'builder/petPortraitColors',
      unitOfMeasure: 'builder/unitOfMeasure',
      totalPlusAdditionalAttributes: 'builder/totalPlusAdditionalAttributes',
      productSlug: 'product/productSlug',
      productName: 'product/productName',
      images: 'product/images',
      selectedSize: 'product/size',
      selectedWidth: 'product/width',
      selectedHeight: 'product/height',
      totalWidth: 'product/totalWidth',
      totalHeight: 'product/totalHeight',
      selectedLayout: 'product/layout',
      selectedBorder: 'product/border',
      selectedBorderColor: 'product/borderColor',
      selectedEdge: 'product/edge',
      selectedFrame: 'product/frame',
      selectedCanvasDepth: 'product/canvasDepth',
      selectedFilter: 'product/filter',
      selectedService: 'product/service',
      selectedOptions: 'product/options',
      note: 'product/note',
      edgeDimension: 'product/edgeDimension',
      borderDimension: 'product/borderDimension',
      borderColorValue: 'product/borderColorValue',
      gapDimension: 'product/gapDimension',
      matDimension: 'product/matDimension',
      frameDimension: 'product/frameDimension',
      cornerRadius: 'product/cornerRadius',
      frameColor: 'product/frameColor',
      edgeColor: 'product/edgeColor',
      uploadLater: 'product/uploadLater',
      supportsAr: 'product/supportsAr',
      panels: 'product/panels',
      petPortraitName: 'product/petPortraitName',
      selectedPetPortraitColor: 'product/selectedPetPortraitColor',
      selectedPetPortraitStyle: 'product/selectedPetPortraitStyle',
      remuxFilters: 'product/remuxFilters',
      remuxLoading: 'product/remuxLoading',

      selectedEditToolId: 'image/selectedEditToolId',
      imageEditTrigger: 'image/imageEditTrigger'
    }),


    aspectRatio () {
      if (this.selectedWidth > this.selectedHeight) {
        return dimensions.LANDSCAPE
      } else if (this.selectedWidth < this.selectedHeight) {
        return dimensions.PORTRAIT
      }

      return dimensions.SQUARE
    },

    selectedImages () {
      if (!this.images[this.pane]) {
        return []
      }

      return [this.images[this.pane].id]
    },

    allPanesHaveImages () {
        const panesIds = this.panes.map(pane => pane.id)
        const imageKeys = Object.keys(this.images).filter(v => panesIds.includes(v))

        return imageKeys.length === panesIds.length
    },

    canAddToCart () {
      return (this.uploadLater || (this.allPanesHaveImages)) && (!this.requiresNotes || (this.requiresNotes && this.hasNote))
    },

    isModifying () {
      const { name } = this.$route

      return name === routes.ROUTE_MODIFY
    },

    requiresNotes () {
      return this.selectedService !== null
    },

    hasNote () {
      return !!this.note
    },

    addToCartLabel () {
      return this.isModifying ? this.$t('message.builder.addToCartLabel.existing') : this.$t('message.builder.addToCartLabel.new')
    },

    addToCartAriaLabel () {
      return !this.canAddToCart ? 'Choose an image to continue' : 'Total:' + this.$filters.currency(this.totalPrice * (this.hasDiscount ? this.discountFactor : 1))
    },

    canShowAR () {
      const anchor = document.createElement('a')
      const deviceSupportsAR = supportsAR(anchor) || (this.featureFlags && this.featureFlags.enableArTesting)
      return this.supportsAr && deviceSupportsAR
    },

    hasDiscount () {
      return this.discountFactor < 1 && (!this.couponSizes.length || this.couponSizes.indexOf(this.selectedSize) !== -1)
    },

    hasCustomSizes () {
      return this.productSlug &&
        (this.customWidths && this.customHeights || this.customSizesOptions)
    },

    supportsUploadLater () {
      let uploadLater = false

      if (this.productSlug) {
        if (this.productSlug === products.PRODUCT_PET_PORTRAIT && this.enableOffline) {
          uploadLater = true
        } else {
          uploadLater = products.SUPPORTS[this.productSlug].uploadLater
        }
      }

      return uploadLater
    },

    multipleImages () {
      return this.productSlug ? products.SUPPORTS[this.productSlug].multipleImages : false
    },

    allDimensions () {
      return [dimensions.SQUARE, dimensions.PORTRAIT, dimensions.LANDSCAPE, dimensions.PANORAMA]
    },

    sizesByAspectRatio () {
      let groupedSizes = {
        [dimensions.SQUARE]: [],
        [dimensions.PORTRAIT]: [],
        [dimensions.LANDSCAPE]: [],
      }
      if(this.sizes) {
        for (let key in this.sizes) {
          const width = parseInt(this.sizes[key].width)
          const height = parseInt(this.sizes[key].height)
          if (width < height) {
            groupedSizes[dimensions.PORTRAIT].push(`${width}|${height}`)
          } else if (width > height) {
            groupedSizes[dimensions.LANDSCAPE].push(`${width}|${height}`)
          } else {
            groupedSizes[dimensions.SQUARE].push(`${width}|${height}`)
          }
        }
      }
      return groupedSizes
    },

    isCollageProduct () {
      switch(this.productSlug) {
        case products.PRODUCT_COLLAGE_CANVAS_PRINT:
        case products.PRODUCT_COLLAGE_FRAMED_PRINT:
        case products.CPPL_PRODUCT_COLLAGE_CANVAS_PRINT:

          return true
        default:

          return false
      }
    },

    isFramedProduct () {
      switch(this.productSlug) {
        case products.PRODUCT_FRAMED_PRINT:
        case products.PRODUCT_ART_FRAMED_PRINT:
        case products.PRODUCT_COLLAGE_FRAMED_PRINT:

          return true
        default:

          return false
      }
    },

    isCollageCanvasProduct () {
      return this.productSlug === products.PRODUCT_COLLAGE_CANVAS_PRINT || this.productSlug === products.CPPL_PRODUCT_COLLAGE_CANVAS_PRINT
    },

    isCollageFramedProduct () {
      return this.productSlug === products.PRODUCT_COLLAGE_FRAMED_PRINT
    },

    isPetPortraitProduct () {
      return this.productSlug === products.CPPL_PRODUCT_PET_PORTRAIT
    },

    isPillowProduct () {
      return this.productSlug === products.CPPL_PRODUCT_PILLOW
    },

    isBlanketProduct () {
      return this.productSlug === products.CPPL_PRODUCT_PHOTO_BLANKET
    },

    showEdgeOptions () {
      return this.edges && Object.keys(this.edges).length > 1
    },

    showFrameOptions () {
      return this.currentFrames && Object.keys(this.currentFrames).length > 1
    },

    widthFactor () {
      return this.productSlug === products.PRODUCT_TRIPTYCH_PRINT ? 3 : 1
    },

    customSizeTriptychSublabel () {
      let sublabel = ''
      if (this.productSlug === products.PRODUCT_TRIPTYCH_PRINT && this.customSize){
        const split = this.selectedSize.split('|')
        const width = parseInt(split[0], 10)
        const height = parseInt(split[1], 10)
        sublabel = this.$t('message.builder.customSizeTriptychSublabel', {width: width, height: height})
      }

      return sublabel
    },

    edgeFrameThumbnailPath () {
      return this.isFramedProduct ? '_' + this.selectedFrame : ''
    },

    frameEdgeThumbnailPath () {
      return this.isFramedProduct ?  '_' + this.selectedEdge : ''
    },

    disableCollageOuterBorder () {
      return true
    },

    borderColorDynamicThumbpath () {

      let thumbpath

      if (this.isCollageProduct) {
        if (this.isCollageCanvasProduct) {
          thumbpath = this.selectedBorder
        } else {
          thumbpath = this.selectedBorder + '_' + this.selectedEdge + '_' + this.selectedFrame
        }
      } else {
        thumbpath = 'RTK'
      }

      return thumbpath
    },

    borderDynamicThumbpath () {

      return this.isCollageFramedProduct ? '_' + this.selectedEdge + '_' + this.selectedFrame : ''
    },

    previewIconClassList () {
      return [
        'py-1 px-2 rounded-full flex items-center space-x-1'
      ]
    },

    enableOffline () {
      return this.featureFlags?.enableOffline
    },

    enableNFT () {
      return false
    },

    hasImages () {
      return Object.keys(this.images).length !== 0
    },

    canEdit () {
      return this.hasImages && !this.isPetPortraitProduct && this.featureFlags?.enableImageEditor && !this.showPreview
    },

    wrapperPaddingClasslist () {
        return 'p-4'
    },

    wrapperClasslist () {
      return [
          'flex-grow relative flex flex-col overflow-hidden',
          this.showStandaloneImageEditor ? 'z-50' : 'z-20'
      ]
    },

    finishedSizeLabel() {
      if (this.selectedSize) {
        const split = this.selectedSize.split('|');
        const width = parseInt(split[0], 10);
        const height = parseInt(split[1], 10);

        const divider = this.productSlug === 'T' ? 3 : 1

        const { totalWidth, totalHeight, unitLabel } = this.calculateDimensions(
          width * divider, height, this.selectedFrame, this.selectedEdge, this.frameDimension,
          this.matDimension, this.gapDimension, this.unitOfMeasure
        );

        let formattedLabel = `${totalWidth}${unitLabel} x ${totalHeight}${unitLabel}`;

        return `<span class="whitespace-nowrap">${this.$t('message.builder.finishedSize')} ${formattedLabel}</span>`;
      } else {
        return null;
      }
    },

    trapFocusEnabled () {
      return !this.showConfirmQuit && !this.error && !this.warning && !this.invalid && !this.showImageSelector
    },

    showImageEditorButton () {
      return !this.showStandaloneImageEditor && (this.hasImages || this.uploadLater)
    },

    disableZoomCrop () {
      return this.isCollageProduct && !this.showStandaloneImageEditor
    },

    photoBorderBleed () {

      return this.isPetPortraitProduct ? 0.25 : 0
    },

    stringifiedImageTransforms () {
      // a key that updates every time a pane transform property is changed
      return JSON.stringify(Object.values(this.images).map(pane => pane.transform))
    }
  },

  async mounted () {
    this.addClasses()
    this.addNoIndex()
    await this.init()
    this.focusBuilder()
    document.addEventListener('keydown', this.handleKeyDown)
  },

  unmounted() {
    this.removeNoIndex()
    this.focusTriggerElement()
    document.removeEventListener('keydown', this.handleKeyDown)
    showChatIcon(this.chatClientInitialized)
  },

  beforeUnmount () {
    this.removeClasses()
    window.removeEventListener('resize', this.checkForMobile)
    document.removeEventListener('keyup', this.handleKeyEscape)
  },

  methods: {
    ...mapActions({
      getProduct: 'builder/getProduct',
      getLineitem: 'builder/getLineitem',
      getArt: 'builder/getArt',
      getSize: 'builder/getSize',
      getImages: 'product/images',
      setImage: 'builder/setImage',
      resetMessages: 'builder/resetMessages',
      cartAdd: 'builder/cartAdd',
      cartUpdate: 'builder/cartUpdate',
      handleStockImage: 'builder/persistStockImage',
      previewInAr: 'builder/previewInAr',
      setError: 'builder/setError',
      setIsSingleSize: 'builder/setIsSingleSize',
      setIsArt: 'builder/setIsArt',
      setCollageSuggestedSizes: 'builder/setCollageSuggestedSizes',
      setArtkitFlow: 'builder/setArtkitFlow',
      setPetPortraitOriginalImage: 'product/setPetPortraitOriginalImage',
      setTrackingMetrics: 'builder/setTrackingMetrics',
      flipSuggestedSizeOrientation: 'builder/flipSuggestedSizeOrientation',
      snapshotBuilderState: 'builder/setSnapshot',
      revertToBuilderState: 'builder/revertToSnapshot',
      triggerDisableSuggestedSizes: 'builder/disableSuggestedSizes',

      setproductSlug: 'product/setproductSlug',
      setProductImage: 'product/setImage',
      setSize: 'product/setSize',
      setSvg: 'product/setSvg',
      setEdge: 'product/setEdge',
      setFrame: 'product/setFrame',
      setCanvasDepth: 'product/setCanvasDepth',
      setDefaultSizes: 'product/setDefaultSizes',
      setLayout: 'product/setLayout',
      setBorder: 'product/setBorder',
      setBorderColor: 'product/setBorderColor',
      setFilter: 'product/setFilter',
      setService: 'product/setService',
      setUploadLater: 'product/setUploadLater',
      setNote: 'product/setNote',
      setPetPortraitAttributes: 'product/setPetPortraitAttributes',
      setPetPortraitName: 'product/setPetPortraitName',
      setTransforms: 'product/setTransforms',
      snapshotProductState: 'product/setSnapshot',
      revertToProductState: 'product/revertToSnapshot',
      setImageRotate: 'product/setImageRotate',

      cancelEdit: 'image/cancelEdit',
    }),

    async init () {

        await this.setProductData()
        await this.setBuilderDefaults()
        await this.setEventListeners()
    },

    async setProductData () {
        const { params, query } = this.$route

        // ?ps= is a single promo size.
        // ?ss= is a preselected size, which means a custom size should get selected.
        const width = query.ps ? parseInt(query.ps.split('|')[0], 10) : null
        const height = query.ps ? parseInt(query.ps.split('|')[1], 10) : null

        // If a promo size is requested, hide custom sizes.
        if (query.ps) {
            this.setIsSingleSize(true)
            this.disableSuggestedSizes()
        }

        let productSlug = query.product || this.productSlug

        switch(productSlug) {
            case products.PRODUCT_ART_SINGLE_PANEL:
            case products.PRODUCT_ART_FRAMED_PRINT:
                this.enableArtMode()
                break;
            case products.PRODUCT_PET_PORTRAIT:
                if (!this.enableOffline) {
                    await this.initializeArtkit()
                }
                break;
            default:
                break;
        }

        // this.handleShowOnboarding()

        // Show an error if the requested product doesn't exist and fall back to a
        // single panel.
        if (!products.DIMENSIONS[productSlug] && productSlug !== products.PRODUCT_METAL_PRINT) {
            productSlug = products.PRODUCT_SINGLE_PANEL

            this.setError(this.$t('message.constants.errors.' + errors.ERROR_WRONG_PRODUCT_CODE))
        }

        this.setproductSlug(productSlug)

        if (this.isModifying) {
            await this.getLineitem(params.id)
            this.disableSuggestedSizes()
            if (this.isCollageProduct) {
                this.setCollageSuggestedSizes({suggestedSizes: this.sizesByAspectRatio[this.aspectRatio].slice(0, 4), fromLineItem: true})
            }

            if (!this.filteredSuggestedSizes[this.selectedSize]) {
                this.customSize = true
            }

            if (this.isPetPortraitProduct) {
              this.petName = this.petPortraitName
              this.colorPickerIsDirty = true
            }
        } else {
            await this.getProduct({ code: productSlug, width, height })

            const selected = query.ss

            if (selected) {
                const selectedWidth = parseInt(query.ss.split('|')[0], 10)
                const selectedHeight = parseInt(query.ss.split('|')[1], 10)

                this.getSize({ code: productSlug, width: selectedWidth, height: selectedHeight })
                this.customSize = true
                this.disableSuggestedSizes()
            }

            // set default pet portrait attributes
        if (this.isPetPortraitProduct) {
          if (this.remuxFilters) {
            this.handleSelectStyle(this.remuxFilters[0])
          }
        }
      }

        // set default sizes
        this.setDefaultSizes(this.sizes)

        // If this is an art piece
        if (query.id) {
            const pid = query.pid ? parseInt(query.pid) : providers.ART_PROVIDER_IMS
            await this.getArt({id : query.id, providerId: pid})
        }
    },
    addNoIndex() {
      let metaRobots = document.querySelector('meta[name="robots"]');
      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.name = 'robots';
        document.head.appendChild(metaRobots);
      }
      metaRobots.content = 'noindex';
    },
    removeNoIndex() {
      let metaRobots = document.querySelector('meta[name="robots"]');
      if (metaRobots) {
        metaRobots.remove()
      }
    },
    async setEventListeners () {
        window.addEventListener('resize', this.checkForMobile)
        document.addEventListener('keyup', this.handleKeyEscape)

        this.chatClientInitialized = await hideChatIcon()
    },

    async setBuilderDefaults () {
        if (this.allPanesHaveImages && !this.isCollageProduct) {
            this.togglePreview(true)
        }

        this.checkForMobile()
    },

    checkForMobile () {
      this.isMobile = !window.matchMedia('(min-width: 768px)').matches
    },

    handleChat () {
      this.$emit('chat')
    },

    handleClose () {
      this.$emit('close')
    },

    handleCloseMessages () {
      this.resetMessages()
    },

    wrapWithParentheses(label) {
      return `(${label})`;
    },

    async handleAddToCart () {
      if (this.selectedEditToolId) {
        this.cancelEdit()
      }

      this.renderMode = true

      await this.$nextTick()

      let el = this.$el.querySelector('#printable')
      el = this.removePrintableTransform(el)
      const svg = sanitizeSvg(serializeSvg(el))

      this.setSvg(svg)

      if (this.isModifying) {
        this.cartUpdate()
      } else {
        const { query } = this.$route

        if (this.isArt && parseInt(query.pid) === providers.ART_PROVIDER_IMS) {
          await this.handleStockImage()
        }
        this.cartAdd()
      }
    },

    handleShowImageSelector () {
      this.showImageSelector = true
    },

    handleShowConfirmQuit () {
      this.showConfirmQuit = true
    },

    addClasses () {
      document.body.classList.add('overflow-hidden', 'lg:overflow-hidden')
      document.body.classList.remove('lg:overflow-auto', 'lg:scrolling-touch')
    },

    removeClasses () {
      document.body.classList.add('lg:overflow-auto', 'lg:scrolling-touch')
      document.body.classList.remove('overflow-hidden', 'lg:overflow-hidden')
    },

    openFlyout (index) {
      this.showFlyout = index
      this.showFlyoutDesktop = index
    },

    closeFlyout (index) {
      if (this.showFlyout === index) {
        this.showFlyout = null
      }
    },

    toggleFlyout(index) {
      this.showFlyout = this.showFlyout === index ? null : index;
      this.showFlyoutDesktop = index;

      if (this.showFlyout !== null && this.isMobile) {
        this.snapshotProductState();
      }
    },

    cancelChanges() {
      if (this.showFlyout !== null && this.isMobile) {
        this.revertToProductState();
        this.closeFlyout(this.showFlyout);
      }
    },

    openMainFlyout () {
      this.openFlyout(0)
    },

    togglePreview (force) {

      if (typeof force !== 'undefined') {
        this.showPreview = force
      } else {
        this.showPreview = !this.showPreview
      }

      this.renderMode = this.showPreview

    },

    enableArtMode () {
      this.setUploadLater(false)
      this.setIsArt(true)

      // only show 3d preview mode
      this.renderMode = true
      this.showPreview = true
    },

    handlePreviewInAr () {
      const svg = document.querySelector('[data-panes]')

      this.previewInAr(serializeSvg(svg))
    },

    handlePaneClick (id) {
      if (!this.isArt && !this.selectedEditToolId) {
        this.pane = id
          if (this.isCollageProduct &&
              !this.showStandaloneImageEditor &&
              this.images[this.pane] &&
              !this.uploadLater) {
              this.snapshotProductState()
              this.showStandaloneImageEditor = true
          } else {
              this.showImageSelector = true
          }
      }
    },

    labelPanels(label) {
      if (label) {
        let formattedLabel = label.replace(/^\d+\s*x\s*/, '');
        return `${this.$t('message.builder.panelsLabel', {size: formattedLabel})}`;
      } else {
        return '';
      }
    },

    finishedSizeLabelPanels(sublabel) {
      if (sublabel) {
        return `${this.$t('message.builder.finishedSize')} ${String(sublabel)}`;
      } else {
        return '';
      }
    },

    async handleSelectImage (image) {

      if (this.selectedImages.indexOf(image.id) === -1) {

        if (this.isPetPortraitProduct && !this.enableOffline) {
          // Save the original PP source image to memory
          this.setPetPortraitOriginalImage(image)
        }
        this.showImageSelector = false
        await this.setImage({ [this.pane]: image })
        await this.$nextTick()

        let el = this.showStandaloneImageEditor ? this.$el.querySelector('#imageEditorPrintable') : this.$el.querySelector('#printable')
        const svg = sanitizeSvg(serializeSvg(el))
        this.setTransforms(svg)

        this.setUploadLater(false)
        this.openMainFlyout()

        if (this.allPanesHaveImages && !this.isCollageProduct && !this.uploadLater) {
            this.togglePreview(true)
        }
      }
    },

    handleSelectSize (size) {
    this.customSize = false
    this.getSize({ code: this.productSlug, width: parseInt(size.width, 10), height: parseInt(size.height, 10) })
    this.disableSuggestedSizes()
    },

    handleSelectEdge (edge) {
      this.setEdge(edge.code)
    },

    handleSelectFrame (frame) {
      this.setFrame(frame.code)
    },

    handleSelectLayout (layout) {
      // update size based on dimension
      if (layout.formfactor !== this.aspectRatio && !this.customSize) {
        let formfactor = layout.formfactor === dimensions.PANORAMA ? dimensions.LANDSCAPE : layout.formfactor
        this.setCollageSuggestedSizes({suggestedSizes: this.sizesByAspectRatio[formfactor].slice(0, 4), fromLineItem: false})
      }

      this.setLayout(layout.code)
    },



    handleKeyDown (event) {
      if (this.trapFocusEnabled) {
        trapTabFocus(this.$refs.builder, this.$refs.closeBtn.$el, event)
      }
    },

    handleSelectBorder (border) {
      this.setBorder(border.code)
    },

    handleSelectBorderColor (borderColor) {
      this.setBorderColor(borderColor.code)
      if (this.productSlug === products.PRODUCT_COLLAGE_CANVAS_PRINT) {
        this.setEdge(borderColor.code)
      }
    },

    handleSelectFilter (filter) {
      this.setFilter(filter.code)
    },

    handleSelectService (service) {
      this.setService(service.code)
    },

    handleUploadLater () {
      this.setUploadLater(true)
        this.showStandaloneImageEditor = false
    },

    handleSelectCustomSize () {
      this.customSize = true
    },

    handleCustomWidth (index) {
      const { value } = this.customWidths[index]
      const width = value / this.widthFactor
      this.getSize({ code: this.productSlug, width: width, height: this.selectedHeight })
      this.handleUserManualSelectCustomSize()
      this.disableSuggestedSizes()
    },

    handleCustomHeight (index) {
      const { value } = this.customHeights[index]
      const width = this.selectedWidth / this.widthFactor
      this.getSize({ code: this.productSlug, width: width, height: value })
      this.handleUserManualSelectCustomSize()
      this.disableSuggestedSizes()
    },

    handleCustomSize (index) {
      const { value } = this.customSizesOptions[index]

      const size = value.split('|')
      const width = parseInt(size[0], 10)/ this.widthFactor
      const height = parseInt(size[1], 10)

      this.getSize({ code: this.productSlug, width: width, height: height })
      this.handleUserManualSelectCustomSize()
      this.disableSuggestedSizes()
    },

    handleNameChange() {
      this.setPetPortraitName(this.petName)
    },

    handleNoteChange(note) {
      this.setNote(note)
    },

    totalSizePrice (size) {
      let sizePrice = 0
      let framePrice = 0

      if (size && this.sizes) {
        sizePrice = this.sizes[size].foreignPrice
        framePrice = this.selectedFrame ? this.sizes[size].frames[this.selectedFrame].foreignPrice : 0
      }

      return sizePrice + framePrice
    },

    framePriceDifference (frame) {
      let framePrice = 0
      let includedFramePrice = 0

      if (frame) {
        framePrice = frame.foreignPrice
        if (this.currentFrames && this.currentFrames['075DW']) {
          includedFramePrice = this.currentFrames['075DW'].foreignPrice
        }
      }

      return framePrice - includedFramePrice
    },

    hasDiscountForSize (size) {
      return this.discountFactor < 1 && (!this.couponSizes.length || this.couponSizes.indexOf(size) !== -1)
    },

    getThumbnailAspectRatio (size) {
      let width = parseInt(size.width, 10)
      const height = parseInt(size.height, 10)

      if (this.productSlug === products.PRODUCT_TRIPTYCH_PRINT) {
        width = width * 3
      }

      if (width > height) {
        return dimensions.LANDSCAPE
      } else if (width < height) {
        return dimensions.PORTRAIT
      }

      return dimensions.SQUARE
    },

    /**
     * @todo use these methods to create fully dynamic thumbnail previews (where
     * the canvas has a real aspect ratio and size).
     */
    getThumbnailSize (size, index) {
      if (!this.isSingleSize) {
        return index
      }

      const width = parseInt(size.width, 10)
      const height = parseInt(size.height, 10)
      const widthAspect = Math.round(width / 72 * 4) - 1
      const heightAspect = Math.round(height / 72 * 4) - 1

      if (width >= height) {
        return widthAspect
      } else if (width < height) {
        return heightAspect
      }
    },

    handleKeyEscape (event) {
      const key = 'which' in event ? event.which : event.keyCode
      if (key === 27) {
        if (!this.showImageSelector) {
          this.handleShowConfirmQuit()
        } else {
          this.showImageSelector = false
        }
      }
    },

    handleSelectStyle (styleCode) {
      const color = this.colorPickerIsDirty ? null : styleCode.defaultBackgroundColor
      this.setPetPortraitAttributes({color: color, style: styleCode.name})
    },

    translateString(key, dynamicString) {

      return translate(key, dynamicString, this)
    },

    handleUserManualSelectCustomSize() {
      if (!this.userManuallySelectedCustom) {
        this.setTrackingMetrics({userManuallySelectedCustom: true})
      }
    },

    calculateDimensions(width, height, selectedFrame, selectedEdge, frameDimension, matDimension, gapDimension, unitOfMeasure) {
      let additionalLength = 0;

      switch (selectedFrame) {
        case 'BF':
        case 'WF':
        case 'EF':
        case 'GF':
        case 'RW':
        case 'NF':
        case 'SF':
          additionalLength += frameDimension * 2;
          if (selectedEdge === '250MA') {
            additionalLength += matDimension * 2;
          } else if (selectedEdge !== '250MA' && selectedEdge !== 'NOMA') {
            additionalLength += gapDimension * 2;
          }

          // subtract frameLipWidth (0.25" per side) if a framed print
          if (selectedEdge === '250MA' || selectedEdge === 'NOMA') {
            additionalLength -= 0.5
          }

          break;
        default:
          break;
      }

      let totalWidth = parseInt(width) + additionalLength;
      let totalHeight = parseInt(height) + additionalLength;

      let unitLabel;
      switch (unitOfMeasure) {
        case measurements.UNIT_CENTIMETERS:
          totalWidth = Math.round(totalWidth * 2.54);
          totalHeight = Math.round(totalHeight * 2.54);
          unitLabel = ' cm';
          break;
        case measurements.UNIT_INCHES:
        default:
          unitLabel = '"';
      }

      return { totalWidth, totalHeight, unitLabel };
    },

    getAdditionalLengthHeading(width, height) {
      const { totalWidth, totalHeight, unitLabel } = this.calculateDimensions(
        width, height, this.selectedFrame, this.selectedEdge, this.frameDimension,
        this.matDimension, this.gapDimension, this.unitOfMeasure
      );

      if (totalWidth && totalHeight && unitLabel) {
        return `(${totalWidth}${unitLabel} x ${totalHeight}${unitLabel} <span class="whitespace-nowrap">${this.$t('message.builder.flyout.sizes.additionalLengthHeadingSuffix')}</span>)`;
      } else {
        return null;
      }
    },

    liveFilterAvailable (filter) {

      return ['BW', 'SP', 'LM', 'VT'].includes(filter) && this.hasImages
    },

    focusBuilder() {
      this.triggerElement = document.activeElement
      this.$nextTick(() => {
        // focus on the builder component on mount
        let builder = this.$refs.builder
        builder?.focus()
      })
    },

    focusTriggerElement() {
      this.$nextTick(() => {
        // focus on the builder component on mount
        this.triggerElement?.focus()
      })
    },

    //  async initializeArtkit() {
    //     const artkitPromise = import(/* webpackChunkName: 'ArtKit' */ '@workshopx/artkit-sdk')
    //    const { client } = await artkitPromise

    //     this.artkit = client.configure({
    //       apiKey: this.artkitToken,
    //    })

    //     const flow = await this.artkit.create('58', {})
    //     this.setArtkitFlow(flow)
    //   },

    removePrintableTransform (el) {
      if (el) el.style.transform = 'none'

      return el
    },

    handleChangeColor (hex) {
      if (!this.colorPickerIsDirty) {
        this.colorPickerIsDirty = true
      }
      this.setPetPortraitAttributes({color: hex})
      this.showColorPicker = false
    },

    // Image editor
    handleApplyImageEdits () {

        let el = this.$el.querySelector('#imageEditorPrintable')
        el = this.removePrintableTransform(el)
        const svg = sanitizeSvg(serializeSvg(el))
        this.setTransforms(svg)
        this.closeImageEditor()
    },

    handleCancelImageEdits () {
        this.revertToBuilderState()
        this.revertToProductState()
        this.closeImageEditor()
    },

    openImageEditor () {
        this.snapshotBuilderState()
        this.snapshotProductState()
        this.showStandaloneImageEditor = true
    },

    closeImageEditor () {
        this.showStandaloneImageEditor = false
    },

    handleOrientationChange () {
        this.flipSuggestedSizeOrientation()
        this.setSize(this.selectedHeight + '|' + this.selectedWidth)
    },

    handleRotateImage () {
      this.setImageRotate(this.pane)
    },

    disableSuggestedSizes () {
      this.triggerDisableSuggestedSizes()
    }
  },
    provide() {
        // use function syntax so that we can access `this`
        return {
          panels: computed(() => this.panels),
          selectedWidth: computed(() => this.selectedWidth),
          selectedHeight: computed(() => this.selectedHeight),
          edgeDimension: computed(() => this.edgeDimension),
          edgeColor: computed(() => this.edgeColor),
          selectedEdge: computed(() => this.selectedEdge),
          renderMode: computed(() => this.renderMode),
          frameDimension: computed(() => this.frameDimension),
          gapDimension: computed(() => this.gapDimension),
          matDimension: computed(() => this.matDimension),
          isMobile: computed(() => this.isMobile),
          selectedEditToolId: computed(() => this.selectedEditToolId),
          wrapperPaddingClasslist: computed(() => this.wrapperPaddingClasslist),
          featureFlags: computed(() => this.featureFlags),
          panes: computed(() => this.panes),
          borderDimension: computed(() => this.borderDimension),
          borderColorValue: computed(() => this.borderColorValue),
          images: computed(() => this.images),
          showPreview: computed(() => this.showPreview),
          uploadLater: computed(() => this.uploadLater),
          isArt: computed(() => this.isArt),
          productSlug: computed(() => this.productSlug),
          disableCollageOuterBorder: computed(() => this.disableCollageOuterBorder),
          imageEditTrigger: computed(() => this.imageEditTrigger),
          locale: computed(() => this.locale),
          cornerRadius: computed(() => this.cornerRadius),
          canEdit: computed(() => this.canEdit),
          frameColor: computed(() => this.frameColor),
          selectedFrame: computed(() => this.selectedFrame),
          filter: computed(() => this.liveFilterAvailable(this.selectedFilter) ? this.selectedFilter : null),
          canManipulate: computed(() => this.productSlug !== this.PRODUCT_ART_SINGLE_PANEL && this.productSlug !== this.PRODUCT_COLLAGE_FRAMED_PRINT),
          aspectRatio: computed(() => this.aspectRatio),
          pane: computed(() => this.pane),
          isCollageProduct: computed(() => this.isCollageProduct),
        }
    }
}

</script>

